module.exports = __webpack_public_path__ + "static/media/storage.f583d5f0.svg";